import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { ILoginUser } from 'src/common/interfaces/dtos/ILoginUser';
import { ITouchPointIdentifier } from 'src/common/interfaces/dtos/ITouchPointIdentifier';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
export const touchpointRegister = async (
  loginUser: ILoginUser,
  touchpointIdParam: string,
  businessUnitId?: string,
): Promise<ITouchPointIdentifier> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/auth/registerTouchPoint/${touchpointIdParam}`,
    method: 'POST',
    data: loginUser,
  };
  if (businessUnitId) {
    axiosConfig.url = `/auth/registerTouchPoint/${businessUnitId}/${touchpointIdParam}`;
  }
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'touchpoint-register' },
  };

  return await emeraldRequest<ITouchPointIdentifier>(emeraldRequestParams);
};
